import { AutoThemeProvider, Tab, Tabs } from '@platform-ui/design-system';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import GenericTable from '../Tables/components/GenericTable';
import { HISTORIES_TABLE_PROPS, TENANTS_TABLE_PROPS } from '../Tables/constants';
import * as ReactDOM from 'react-dom/client';

const TenantsView = (props) => {

    const [tabs, setTabs] = useState(0);

    const root = ReactDOM.createRoot(document.getElementById("pageHeader"));
    root.render(
        <AutoThemeProvider>
        <h2>{"Tenants"}</h2>
        <Tabs
                    a11yLabel="tab"
                    value={tabs}
                    dsOnChange={(_, newIndex) => {
                        if (newIndex === 0) {
                            setTabs(0);
                        }
                        if (newIndex === 1) {
                            setTabs(1);
                        }
                        }}
            
                    e2e="tenants-tabs"
                    >
                    <Tab
                        id="tenant-tab"
                        e2e="tenants"
                        label="Tenants"
                    />
                    <Tab
                        id="history-tab"
                        e2e="history"
                        label="History"
                    />
                    
                </Tabs>
                </AutoThemeProvider>
      );

    return (
        <AutoThemeProvider>
            {tabs === 0 && <GenericTable {...TENANTS_TABLE_PROPS} {...props.tables.tenants_table}/>}
            {tabs === 1 && <GenericTable {...HISTORIES_TABLE_PROPS} {...props.tables.histories_table}/>}
        </AutoThemeProvider>
    )
}

TenantsView.propTypes = {
    tables: PropTypes.object
}

export default TenantsView;